module.exports = __webpack_public_path__ + "static/media/Goodnest_android_3_preview.5fae896e.jpg";